import React, { useEffect } from "react";
import AiDevelopmentHero from "./AiDevelopmentHero";
import LatestAiDevelopment from "./LatestAiDevelopment";
import OurAiServices from "./OurAiServices";
import TechStack from "./TechStack";
import AiCta from "./AiCta";
import AiWhyChooseUs from "./AiWhyChooseUs";
import HelmetMetaTag from "../Components/HelmetMetaTag";

export default function AiDevelopment() {
  const searchParam = new URLSearchParams(window.location.search).get("tab");
  useEffect(() => {
    if (searchParam) {
      const element = document.getElementById("latest-ai-development");
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: "smooth",
      });
    }
  }, []);
  return (
    <React.Fragment>
      <HelmetMetaTag
        titleName="AI Development Services | AI Solutions | SprigStack"
        desc="Sprigstack is an AI development company  that creates custom AI-powered products. We build AI solutions to streamline workflows and deliver actionable insights."
        canonical={window.location.href}
        ogtitle="AI Development Services | AI Solutions | SprigStack"
        ogdesc="Sprigstack is an AI development company  that creates custom AI-powered products. We build AI solutions to streamline workflows and deliver actionable insights."
        ogtype="website"
        ogurl={window.location.href}
      />
      <div className="row">
        <div className="col-12">
          <AiDevelopmentHero />
        </div>
        <div className="col-12 px-6" id="latest-ai-development">
          <LatestAiDevelopment searchParam={searchParam} />
        </div>
        <div className="col-12">
          <OurAiServices />
        </div>
        <div className="col-12">
          <TechStack />
        </div>
        <div className="col-12 px-6">
          <AiCta />
        </div>
        <div className="col-12">
          <AiWhyChooseUs />
        </div>
      </div>
    </React.Fragment>
  );
}
